import React from 'react';

import {
    Fade,
} from "react-reveal"; 

const CertificationCard = ({data}) => {
    return ( 
        <Fade left duration={1000} distance="40px">
            <div>
                <a href={data.link} target="_blank">
                    <img src={data.name} className="certification-icon" alt=""/>
                </a>
            </div>
		</Fade>
     );
}

export default CertificationCard;